import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    display: none;
    visibility: hidden;
    opacity: 0;
    max-height: 0;
  }

  50% {
    opacity: 1;
  }

  to {
    display: block;
    visibility: visible;
    max-height: 500px; //bigger than what we would ever actually need
  }
`;

const SlideInAnimation = styled.div`
  animation: ${slideIn} 1s;
`;

export default SlideInAnimation;
